import { BrowserRouter, Routes, Route } from "react-router-dom";
import FocusFlow from "./pages/FocusFlow";
import Profile from "./pages/Profile";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FocusFlow />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
